import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate } from 'react-router-dom';

// api
import AuthenticationService from '../../service/authentication-service';

// tools
import handleSuccessAndDisplay from '../../helpers/handleSuccessAndDisplay';
import { hasDetailMessages, transformAndDisplay } from '../../helpers/transformErrorResponse';
import handleErrorAndDisplay from '../../helpers/handleErrorAndDisplay';

// components
import LogoIcon from '../../icons/LogoIcon';
import { useForm } from 'react-hook-form';
import FormField from '../../components/FormField';
import ButtonFormSubmit from '../../components/ButtonWrapper/components/ButtonFormSubmit';

const UpdatePassword = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const {
        control,
        handleSubmit,
        formState: { isValid },
        watch
    } = useForm({ mode: 'onChange' });

    const passwordValue = watch('new_password');

    const onSubmit = (formData) => {
        setLoading(true);

        AuthenticationService.resetPassword(formData, callback, errCallback)
    };

    const callback = () => {
        handleSuccessAndDisplay(__('Success!', 'soundbetween'));
        setTimeout(() => {
            navigate('/', { replace: true });
        }, 2000);
        setLoading(false);
    }

    const errCallback = (resp) => {
        if (hasDetailMessages(resp)) {
            transformAndDisplay(handleErrorAndDisplay, resp);
        }
        setLoading(false);
    }

    // Email validation rules
    const codeValidationRules = {
        required: __('Code is required', 'soundbetween')
    };

    // Password validation rules
    const passwordValidationRules = {
        required: __('Password is required', 'soundbetween'),
        minLength: {
            value: 8,
            message: __('Password must be at least 8 characters long', 'soundbetween')
        }
    };

    // Confirm password validation rules
    const confirmPasswordValidationRules = {
        required: __('Please confirm your password', 'soundbetween'),
        minLength: {
            value: 8,
            message: __('Password must be at least 8 characters long', 'soundbetween')
        },
        validate: (value) => {
            if (value !== passwordValue) {
                return __('Passwords do not match', 'soundbetween');
            }
            return true;
        }
    };

    return (
        <div className={['appPage', 'appPageLogin'].join(' ')}>
            <div className="appPageLogin__wrapper">

                <LogoIcon/>

                <div className="loginCard">
                    <span className="loginCard__title">{__('Update password', 'soundbetween')}</span>
                    <span className="loginCard__subttitle">
                        {__('Enter the verification code from your email and a new password', 'soundbetween')}
                    </span>

                    <form className="appForm" onSubmit={handleSubmit(onSubmit)}>
                        <fieldset>
                            <FormField
                                type="text"
                                name="code"
                                placeholder={__('Verification code', 'soundbetween')}
                                control={control}
                                rules={codeValidationRules}
                            />

                            <FormField
                                type="password"
                                name="new_password"
                                placeholder={__('Password', 'soundbetween')}
                                description={__('The password must contain at least 8  characters', 'soundbetween')}
                                control={control}
                                rules={passwordValidationRules}
                            />

                            <FormField
                                type="password"
                                name="confirm_new_password"
                                placeholder={__('Confirm Password', 'soundbetween')}
                                control={control}
                                rules={confirmPasswordValidationRules}
                            />
                        </fieldset>

                        <ButtonFormSubmit onClick={() => {}} disabled={loading || !isValid}>
                            {__('Confirm', 'soundbetween')}
                        </ButtonFormSubmit>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default UpdatePassword;